import { DebugService } from '../../../shared/services/debug.service.js';
import { REFI_PERSONAL_CONST } from '../../../shared/constants/app.constants.js';

class _CookieService {
  constructor() {
    this.debug = new DebugService('CookieService');
  }

  getCookie(key) {
    return document.cookie
      ?.split('; ')
      ?.find((row) => row.startsWith(key))
      ?.split('=')[1];
  }

  removeCookie(key) {
    if (this.getCookie(key)) {
      document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
    }
  }

  get pfci() {
    return this.getCookie(REFI_PERSONAL_CONST.REFI_CI_KEY);
  }
}

export const CookieService = new _CookieService();
